import React from 'react';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section id="cta" className="w-full bg-white" data-id="element-28" data-mp="2iytlxp3jg7o4">
      <div className="max-w-3xl mx-auto px-5 md:px-8 pb-16 md:pb-20 flex justify-center" data-id="element-29" data-mp="2ix0fa9sxdng4">
        <CtaButton size="large" data-id="element-30" data-mp="2e09zlnl18tv8" />
      </div>
    </section>;
}